var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'underscore', 'core', 'app-common/component/service-call', 'view/transactions-report', 'component/report/transactions-table', 'component/report/export-report', 'app-common/component/loader', 'component/range-selector', 'common/component/date-formatter', 'common/component/money-formatter', 'component/report/editing', 'app-common/component/api-call', 'template/report/data/statement-section.htm'], function($, _, core, serviceCall, TransactionsReportView, transactionsTable, reportExport, loader, rangeSelector, dateFormatter, moneyFormatter, editing, apiCall, sectionTemplate) {
  /*
  # Base class for Income statement and Balance Sheet widgets
  #
  # Component has two pages - ledgers and transactions.
  # Current page can be found by checking settings.isLedgersPage flag.
  #
  # Ledgers page contains ledgers and its amounts sorted by categories.
  # It uses settings.ledgersUrl property and loadLedgers method and related
  # actions.
  #
  # Transactions page contains transactions like TransactionsReportView class.
  */

  var LedgerReportView;
  return LedgerReportView = (function(_super) {

    __extends(LedgerReportView, _super);

    function LedgerReportView() {
      LedgerReportView.__super__.constructor.apply(this, arguments);
    }

    LedgerReportView.prototype.events = {
      'click .range-item:not(.range-disabled) .status-change:not(.selected)': 'changeStatus'
    };

    LedgerReportView.prototype.statusMessages = {};

    /*
    # @param {Object} options contains id, title and icon, report-related data, URLs, template
    	    # @param {Array} params additional information passed to widget with ID
    */


    LedgerReportView.prototype.initialize = function(options) {
      var ledger, ledgerId, transactionsPageParamsNumber, _ref;
      LedgerReportView.__super__.initialize.apply(this, arguments);
      this.settings.ledgersUrl = options.ledgersUrl;
      this.settings.isLedgersPage = true;
      this.settings.statusManage = true;
      this.data.currentLedgerId = null;
      this.data.currentLedgerCategory = null;
      this.data.currentLedgerText = null;
      this.data.ledgerCategories = options.ledgerCategories;
      this.data.reportLedgers = [];
      this.templates.ledgerSection = sectionTemplate;
      this.statusMessages[rangeSelector.Status.FINISHED] = 'This report was completed on {{date}}. <span class="ss-check ss-gizmo report-state-icon finished"></span>';
      this.statusMessages[rangeSelector.Status.INPROGRESS] = 'This report is in progress. <span class="ss-write ss-gizmo report-state-icon in-progress"></span>';
      this.statusMessages[rangeSelector.Status.CLOSED] = 'This report was closed on {{date}}. <span class="ss-write ss-gizmo report-state-icon in-progress"></span>';
      transactionsPageParamsNumber = [2, 6, 8];
      if (!this.settings.params || !this.settings.params.length) {
        this.settings.isLedgersPage = true;
      } else if (_ref = this.settings.params.length, __indexOf.call(transactionsPageParamsNumber, _ref) >= 0) {
        ledgerId = this.settings.params[1];
        ledger = _.findWhere(core.getCollection('ledgerAccounts').toJSON(), {
          id: ledgerId
        });
        this.settings.isLedgersPage = false;
        this.data.currentLedgerCategory = this.settings.params[0];
        this.data.currentLedgerId = ledgerId;
        this.data.currentLedgerText = ledger.name;
      }
      return this.loadLedgers();
    };

    LedgerReportView.prototype.initUI = function() {
      LedgerReportView.__super__.initUI.apply(this, arguments);
      this.on('report:recalculate-amounts', this.updateLedgerTotalBalance);
      this.showFeature('download');
      this.initExportReportLinks();
      if (this.settings.isLedgersPage) {
        this.hideFeature('edit');
        this.hideFeature('overview');
        return $(document).on('click', '.section-row td', function(event) {
          if (event.target.nodeName.toLowerCase() === 'td') {
            return $(this).closest('tr').find('.router-url').click();
          }
        });
      } else {
        this.showFeature('edit');
        this.showFeature('overview');
        $('.report-name').html(this.data.currentLedgerText);
        return this.initBackButtonFeature(this.settings.title, this.settings.type);
      }
    };

    LedgerReportView.prototype.remove = function() {
      LedgerReportView.__super__.remove.apply(this, arguments);
      $(document).off('click', '.section-row td');
      this.off('report:recalculate-amounts');
      return this.off('ledger-report:after-load-ledgers');
    };

    LedgerReportView.prototype.initReportDateIntervals = function() {
      var end, endMarkerIndex, start, startMarkerIndex;
      startMarkerIndex = this.settings.params.indexOf('start');
      endMarkerIndex = this.settings.params.indexOf('end');
      if (startMarkerIndex >= 0 && endMarkerIndex >= 0) {
        start = this.settings.params[startMarkerIndex + 1];
        end = this.settings.params[endMarkerIndex + 1];
        this.updateReportIntervalFromURL(start, end);
      }
      if (this.settings.params.length === 0) {
        return this.updateReportURLFromInterval([]);
      }
    };

    LedgerReportView.prototype.dateChangeAction = function() {
      this.changeDownloadUrl();
      this.updateUrl();
      this.updateReportStatus();
      if (this.settings.isLedgersPage) {
        this.loadLedgers();
      } else {
        this.loadData();
      }
      return this.initExportReportLinks();
    };

    LedgerReportView.prototype.updateReportStatus = function() {
      var finishedDate, message, reportStatus, _ref;
      _ref = LedgerReportView.__super__.updateReportStatus.apply(this, arguments), reportStatus = _ref[0], finishedDate = _ref[1];
      message = this.statusMessages[reportStatus];
      message = message.replace('{{date}}', dateFormatter.format(finishedDate, {
        shortMonth: true,
        suffix: true
      }));
      this.$el.find('.report-state-message').html(message);
      return this.$el.find('.report-state').show();
    };

    LedgerReportView.prototype.changeStatus = function(e) {
      var $el, date, dateData, dateString, intervalType,
        _this = this;
      intervalType = rangeSelector.getSelectedIntervalType();
      $el = $(e.currentTarget);
      dateData = $el.data('date');
      dateString = intervalType === 'YEAR' ? dateData + ' 01 01' : dateData;
      date = Date.parse(dateString);
      loader.init({
        spinnerContainer: '.page-wrapper'
      });
      return (serviceCall('report', "report/metadata.json/client/" + (core.getCurrentClientId()) + "/date/" + (date.toString('yyyyMMdd')) + "/interval/" + (rangeSelector.getSelectedIntervalType()) + "/status/" + ($el.data('status')), 'PUT')).always(function() {
        loader.hide();
        return core.getRouter().refreshPage(null, _this.settings.params);
      });
    };

    /*
    # Loading ledger data according to settings.ledgersUrl property
    */


    LedgerReportView.prototype.loadLedgers = function() {
      var intervalAsDates,
        _this = this;
      intervalAsDates = rangeSelector.getIntervalAsDates();
      loader.init();
      this.loadingPromise = serviceCall('report', this.settings.ledgersUrl(core.getCurrentClientId(), intervalAsDates.from.toString('yyyy-MM-dd'), intervalAsDates.to.toString('yyyy-MM-dd')), 'GET', null, 'json');
      this.addUnavailableMessage(this.loadingPromise);
      return this.loadingPromise.done(function(data) {
        if (!_this.UILoaded) {
          _this.initUI();
        }
        loader.hide();
        LedgerReportView.ledgerData = data;
        if (_this.settings.isLedgersPage) {
          return _this.renderLedgers();
        } else {
          return _this.loadData(_this.pageNum);
        }
      });
    };

    /*
    # @param {string} id Ledger account id
    # @return {string} total amount for specified ledger
    */


    LedgerReportView.prototype.getLedgerTotal = function(id) {
      if (this.hasType('income-statement')) {
        switch (id) {
          case "revenues":
            return LedgerReportView.ledgerData.totalRevenue;
          case "expenses":
            return LedgerReportView.ledgerData.totalCost;
          case "profit":
            return LedgerReportView.ledgerData.profit;
          case "netprofit":
            return LedgerReportView.ledgerData.netProfit;
          case "cogsexpenses":
            return LedgerReportView.ledgerData.totalCogsExpense;
          case "operatingexpenses":
            return LedgerReportView.ledgerData.totalOperatingExpense;
          case "grossprofit":
            return LedgerReportView.ledgerData.grossProfit;
          default:
            return '';
        }
      } else if (this.hasType('balance-sheet')) {
        switch (id) {
          case "assets":
            return LedgerReportView.ledgerData.totalAssets;
          case "liabilities":
            return LedgerReportView.ledgerData.totalLiabilities;
          case "equity":
            return LedgerReportView.ledgerData.totalEquity;
          default:
            return '';
        }
      } else {
        return '';
      }
    };

    LedgerReportView.prototype.getCogsAwareLedgerCategories = function() {
      var categories, ledgerData;
      ledgerData = LedgerReportView.ledgerData;
      categories = ledgerData.hasCogsTransactions === true ? ['revenues', 'cogsexpenses', 'grossprofit', 'operatingexpenses', 'netprofit'] : ['revenues', 'operatingexpenses', 'netprofit'];
      return _.filter(this.data.ledgerCategories, function(cat) {
        var _ref;
        return _ref = cat.id, __indexOf.call(categories, _ref) >= 0;
      });
    };

    LedgerReportView.prototype.getLedgerCategories = function() {
      if (this.hasType('income-statement')) {
        return this.getCogsAwareLedgerCategories();
      } else {
        return this.data.ledgerCategories;
      }
    };

    LedgerReportView.prototype.renderLedgers = function() {
      var accountData, accountItem, alphaSort, catOrders, end, ledgerCategory, start, template, total, _i, _j, _len, _len1, _ref, _ref1, _ref2;
      _ref = this.getIntervalDates(true), start = _ref[0], end = _ref[1];
      $('.widget .widget_content').html('');
      catOrders = core.getLedgerAccountCategoryOrders();
      _ref1 = this.getLedgerCategories();
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        ledgerCategory = _ref1[_i];
        accountData = (_ref2 = LedgerReportView.ledgerData.categories) != null ? _ref2[ledgerCategory.id] : void 0;
        if (accountData != null) {
          alphaSort = catOrders.find(function(cat) {
            return cat.categoryId === ledgerCategory.mainappId && cat.type === "ALPHABETICAL";
          });
          if (alphaSort) {
            accountData = _.sortBy(accountData, function(item) {
              return item[0].name;
            });
          }
          for (_j = 0, _len1 = accountData.length; _j < _len1; _j++) {
            accountItem = accountData[_j];
            accountItem.url = core.getRouter().buildUrl(this.getType(), [ledgerCategory.id, accountItem[0].id, 'start', start, 'end', end]);
            accountItem.formattedAmount = moneyFormatter.formatNumber(accountItem[1]);
          }
        }
        total = this.getLedgerTotal(ledgerCategory.id);
        template = _.template(this.templates.ledgerSection, {
          sectionId: ledgerCategory.id,
          title: ledgerCategory.title,
          account: accountData,
          totalTitle: 'Total ' + ledgerCategory.title.toLowerCase(),
          totalValue: moneyFormatter.formatNumber(total),
          singleLine: ledgerCategory.singleLine
        });
        $('.widget .widget_content').append(template);
      }
      try {
        return $.scrollTo('0px', this.settings.scrollSpeed);
      } catch (e) {

      }
    };

    LedgerReportView.prototype.getQueryParamsForTransactionsLoading = function(toPage) {
      var parameters;
      parameters = LedgerReportView.__super__.getQueryParamsForTransactionsLoading.apply(this, arguments);
      if (this.data.currentLedgerId) {
        parameters['ledger-id'] = this.data.currentLedgerId;
      }
      return parameters;
    };

    LedgerReportView.prototype.afterLoadTransactions = function(data, page, searchString) {
      this.updateLedgerTotalBalanceTitle(data);
      return LedgerReportView.__super__.afterLoadTransactions.apply(this, arguments);
    };

    LedgerReportView.prototype.updateLedgerTotalBalance = function() {
      var promise, url,
        _this = this;
      if (!this.data.currentLedgerId) {
        return;
      }
      url = this.getTransactionsUrl(this.getQueryParamsForTransactionsLoading(1));
      promise = serviceCall('report', url, 'GET', null, 'json');
      this.addUnavailableMessage(promise);
      return promise.done(function(data) {
        return _this.updateLedgerTotalBalanceTitle(data);
      });
    };

    LedgerReportView.prototype.updateLedgerTotalBalanceTitle = function(totals) {
      var money;
      money = moneyFormatter.formatNumber(totals.balance);
      if (this.$el.find(".report-amount").length > 0) {
        return this.$el.find(".report-amount").html(money);
      } else {
        return this.$el.find('.report-name').after("<div class='report-amount'>" + money + "</div>");
      }
    };

    LedgerReportView.prototype.infiniteScrollingAction = function(page) {
      if (this.settings.isLedgersPage) {
        return;
      }
      return LedgerReportView.__super__.infiniteScrollingAction.apply(this, arguments);
    };

    /*
    # @return {string} reportExport type
    */


    LedgerReportView.prototype.getReportExportType = function(isTransactions) {
      if (isTransactions == null) {
        isTransactions = false;
      }
      if (isTransactions) {
        return reportExport.TRANSACTIONS;
      } else if (this.hasType('income-statement')) {
        return reportExport.INCOME_STATEMENT;
      } else if (this.hasType('balance-sheet')) {
        return reportExport.BALANCE_SHEET;
      }
    };

    LedgerReportView.prototype.initExportReportLinks = function() {
      var intervalAsDates, intervalType;
      intervalAsDates = rangeSelector.getIntervalAsDates();
      intervalType = rangeSelector.getIntervalType();
      return reportExport.updateLinks($('#download-link'), core.getCurrentClient().toJSON(), this.getReportExportType(), intervalAsDates.from.toString('yyyy-MM-dd'), intervalAsDates.to.toString('yyyy-MM-dd'), this.getReportTimeScaleByInterval(intervalType), this.data.currentLedgerId);
    };

    /*
    # @param {string} searchKey
    */


    LedgerReportView.prototype.searchAction = function(searchKey) {
      return this.searchLoad({
        queryVals: {
          returl: this.getType(),
          searchkey: searchKey
        }
      }, [this.data.currentLedgerId]);
    };

    LedgerReportView.prototype.editAction = function(savedData) {
      var $target, containsCurrentLedgerId, document, item, _i, _len, _ref;
      if (!savedData || !_.isArray(savedData) || !this.data.currentLedgerId) {
        return;
      }
      for (_i = 0, _len = savedData.length; _i < _len; _i++) {
        item = savedData[_i];
        document = _.findWhere(this.data.items, {
          id: item.documentId
        });
        containsCurrentLedgerId = (_ref = this.data.currentLedgerId.toString(), __indexOf.call(_.pluck(document.dataEntries, 'ledgerAccountId'), _ref) >= 0);
        if (!containsCurrentLedgerId) {
          $target = this.transactionsTable.getTransactionRow(item.documentId);
          $target.velocity('transition.slideLeftOut', {
            duration: 500,
            complete: function() {
              return $target.remove();
            }
          });
        }
      }
      return this.trigger('report:recalculate-amounts');
    };

    LedgerReportView.prototype.transactionViewChangeHandler = function(e) {
      var $target, containsCurrentLedgerId, ledgerAccountIds, _ref;
      LedgerReportView.__super__.transactionViewChangeHandler.apply(this, arguments);
      if (e.data.dataEntries != null) {
        ledgerAccountIds = _.pluck(e.data.dataEntries, 'ledgerAccountId');
        containsCurrentLedgerId = (_ref = this.data.currentLedgerId.toString(), __indexOf.call(ledgerAccountIds, _ref) >= 0);
        $target = this.transactionsTable.getTransactionRow(e.data.id);
        if (!containsCurrentLedgerId) {
          $target.velocity('transition.slideLeftOut', {
            duration: 500,
            complete: function() {
              return $target.remove();
            }
          });
        }
        return this.trigger('report:recalculate-amounts');
      }
    };

    return LedgerReportView;

  })(TransactionsReportView);
});
